var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DonForm'),_c('div',{staticClass:"pa-5"},[_c('v-card',{attrs:{"flat":""}},[_c('h3',{staticClass:"title"},[_vm._v(" Liste des dons ")]),_c('DonListe',{attrs:{"dons":_vm.dons}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }